import { useEffect, useRef } from 'react';

export default function Login() {
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    window.location.replace('/api/auth/login');
  }, []);
  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-brand-50 to-white px-4">
      <div className="bg-white shadow-xl rounded-2xl p-10 max-w-md w-full text-center">
        <div className="text-3xl font-semibold text-brand-700 mb-2">Nexify Lead</div>
        <p className="text-slate-500 mb-8">
          Transforme intenção comercial em uma lista de empresas qualificadas.
        </p>
        <p role="status" className="text-brand-700">
          Conectando à Conta Nexify…
        </p>
        <p className="text-xs text-slate-400 mt-6">
          A autenticação é feita pelo Nexify DDNS Router. Nenhuma senha é armazenada aqui.
        </p>
      </div>
    </div>
  );
}
